<template>
    <div class="ie-view">
        <h1>Fuck Internet Explorer</h1>
    </div>
</template>

<script>
export default {
}
</script>

<style scoped lang="scss">
.ie-view{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
}
</style>
